/*
 * DATORACODE - Kombinierte Fortschritts-Leiste im Cart-Drawer (CFSN-651, Variante B).
 * Meilensteine: Free-Shipping (Liquid-Daten, synchron aus dem DOM) + N Gratisgeschenk-
 * Schwellen (co2.thresholdAvailabilities). Reached-Status je Meilenstein kommt aus der
 * jeweils eigenen, unveraenderten Quelle (Shipping: threshold/eligible-total aus
 * cart-drawer-combined-progress.liquid; Gifts: co2), keine gemeinsame Subtotal-Neuberechnung.
 * Rendert die Shipping-Markierung sofort synchron beim Laden (keine co2-Abhaengigkeit),
 * damit sie beim Oeffnen des Drawers nicht erst auf ein co2-Event warten muss — die
 * Gift-Marker kommen asynchron dazu, sobald co2 antwortet.
 * Mechanik (Dual-Trigger, Trailing-Edge-Debounce) analog assets/free-products.js /
 * assets/tiered-pricing.js.
 */
(function () {
  var isHandling = false;
  var pending = false;

  /* ─── Helpers ───────────────────────────────────────────────── */

  /* Das Snippet wird zweimal pro Seite gerendert (Empty-State + scrollbarer Bereich,
     analog cart-drawer-free-shipping.liquid) — CSS blendet je nach Warenkorb-Status
     eines der beiden aus. */
  function getRoots() {
    return document.querySelectorAll('[data-combined-progress-root]');
  }

  /* Der Root im scrollbaren Bereich (#CartDrawer-CartItems) wird von BEIDEN Update-Pfaden
     in assets/cart.js aktualisiert (voller .drawer__inner-Refresh bei Menge/Entfernen UND
     der partielle cart-drawer-items-Refresh bei externen Cart-Updates, z. B. ATC-Modal).
     Der Empty-State-Root (.drawer__inner-empty) wird dagegen nur vom ersten Pfad erreicht.
     Shipping-Daten deshalb IMMER aus diesem zuverlässigeren Root lesen, nicht aus
     irgendeinem der beiden — sonst kann der Empty-State-Root bei einem externen Update
     veraltete Werte anzeigen (PR-Review-Fund). */
  function getCanonicalShippingRoot(roots) {
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].closest('#CartDrawer-CartItems')) return roots[i];
    }
    return roots[0];
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Template escapen, {{ target }} escaped einsetzen, {{ amount }} als fett hervorgehobenes
     Money-HTML (transcy-money) unescaped durchschleusen — gleiches Muster wie withAmount()
     in assets/free-products.js (DFSO-37: transcy-money-Span darf nicht escaped werden). */
  function fillHeadline(template, amountCents, target) {
    var AMOUNT_PLACEHOLDER = '___AMOUNT_PLACEHOLDER___';
    var escaped = escapeHtml(String(template || ''))
      .replace(/\{\{\s*amount\s*\}\}/g, AMOUNT_PLACEHOLDER)
      .replace(/\{\{\s*target\s*\}\}/g, escapeHtml(target));
    var amountHtml = '<strong class="cart-drawer__combined-progress__status-amount">' + formatPrice(amountCents) + '</strong>';
    return escaped.split(AMOUNT_PLACEHOLDER).join(amountHtml);
  }

  function hideBar(root) {
    root.hidden = true;
    root.innerHTML = '';
  }

  function showBar(root, html) {
    root.innerHTML = html;
    root.hidden = false;
  }

  /* Icon-SVGs werden von Liquid als <template> ins Root-Markup gerendert (nur Liquid kennt
     inline_asset_content). Muessen VOR dem ersten render()-Aufruf ausgelesen werden, da
     showBar() root.innerHTML komplett ersetzt und die Templates sonst geloescht waeren. */
  function readIcon(root, selector) {
    var tpl = root.querySelector(selector);
    return tpl ? tpl.innerHTML : '';
  }

  var icons = { shipping: '', gift: '' };
  (function cacheIcons() {
    var firstRoot = getRoots()[0];
    if (!firstRoot) return;
    icons.shipping = readIcon(firstRoot, '[data-icon-shipping]');
    icons.gift = readIcon(firstRoot, '[data-icon-gift]');
  })();

  /* ─── Meilenstein-Ermittlung ────────────────────────────────── */

  function buildShippingMilestone(root) {
    var threshold = parseInt(root.dataset.shippingThreshold, 10) || 0;
    if (threshold <= 0) return null;
    var eligibleTotal = parseInt(root.dataset.eligibleTotal, 10) || 0;
    var remaining = Math.max(threshold - eligibleTotal, 0);
    return {
      type: 'shipping',
      threshold: threshold,
      reached: remaining <= 0,
      available: true,
      current: eligibleTotal,
      remaining: remaining,
      icon: icons.shipping,
      label: root.dataset.textMilestoneShipping || '',
    };
  }

  /* co2.thresholdAvailabilities(true) liefert ALLE konfigurierten Gift-Schwellen, (false) nur die
     bereits erreichten (unabhaengig von der Verfuegbarkeit) — daraus laesst sich der reached-State
     ohne eigene Subtotal-Berechnung ableiten. `available` ist dabei ein Anzeige-Zustand, KEIN
     Filter: ausverkaufte Schwellen bleiben als Ziel auf der Leiste sichtbar.
     co2.nextFreeProducts().sub_total ist die aktuelle co2-Warenkorbsumme und gilt fuer ALLE
     Gift-Schwellen, nicht nur fuer die naechste. */
  /* Rueckgabe null = Gift-Status NICHT ermittelbar (co2 fehlt oder faellt aus). Das ist etwas
     anderes als ein leeres Array (co2 antwortet, es gibt schlicht keine Gift-Kampagne) — nur im
     zweiten Fall darf die Bar spaeter einen Vollstand verkuenden. */
  async function buildGiftMilestones(root) {
    if (typeof co2 === 'undefined' || typeof co2.thresholdAvailabilities !== 'function') return null;
    try {
      var all = (await co2.thresholdAvailabilities(true)) || [];
      var reachedList = (await co2.thresholdAvailabilities(false)) || [];
      var reachedSet = {};
      reachedList.forEach(function (t) {
        reachedSet[t.thresh] = true;
      });

      var nextGift = null;
      if (typeof co2.nextFreeProducts === 'function') {
        try {
          nextGift = await co2.nextFreeProducts();
        } catch (e) {
          nextGift = null;
        }
      }

      /* nextFreeProducts() liefert false, sobald keine einloesbare Schwelle mehr offen ist —
         dann bleibt die co2-Summe unbekannt (null) und das Segment zeigt keinen Teilfortschritt. */
      var giftSubTotal = nextGift && typeof nextGift.sub_total === 'number' ? nextGift.sub_total : null;

      return all.map(function (t) {
        return {
          type: 'gift',
          threshold: t.thresh,
          reached: !!reachedSet[t.thresh],
          available: t.available !== false,
          current: giftSubTotal,
          /* null = Restbetrag unbekannt. Nicht 0 — sonst kuendigt die Bar "Nur noch 0,00 €" an. */
          remaining: giftSubTotal === null ? null : Math.max(t.thresh - giftSubTotal, 0),
          icon: icons.gift,
          label: root.dataset.textMilestoneGift || '',
        };
      });
    } catch (e) {
      return null;
    }
  }

  /* ─── Render ────────────────────────────────────────────────── */

  /* Ziel, Einloesbarkeit und Erreicht sind drei getrennte Konzepte:
     - Angekuendigt wird nur ein offener und EINLOESBARER Meilenstein — sonst verspricht die Bar
       ein ausverkauftes Geschenk.
     - "Alles erreicht" nur, wenn JEDES konfigurierte Ziel erreicht und einloesbar ist.
     - giftsChecked=false heisst: der Gift-Status wurde in diesem Zyklus noch nicht geprueft
       (Sofort-Render nur mit Shipping-Daten) — dann noch gar nichts verkuenden. */
  function buildHeadline(root, milestones, giftsCheckedNow) {
    var next = null;
    for (var i = 0; i < milestones.length; i++) {
      /* remaining === null: Restbetrag unbekannt — dann keinen Betrag versprechen. */
      if (!milestones[i].reached && milestones[i].available && milestones[i].remaining !== null) {
        next = milestones[i];
        break;
      }
    }
    if (next) {
      var targetLabel = next.type === 'shipping' ? root.dataset.textTargetShipping : root.dataset.textTargetGift;
      return fillHeadline(root.dataset.textRemainingHtml, next.remaining, targetLabel || '');
    }
    var everythingDelivered = milestones.every(function (m) {
      return m.reached && m.available;
    });
    if (!giftsCheckedNow || !everythingDelivered) return '&nbsp;';
    return escapeHtml(root.dataset.textAllReached || '');
  }

  /* Mehrere Vorteile koennen auf demselben Betrag liegen (Versand ab 100 € UND Geschenk ab
     100 €). Die Marker-Position ist eine reine Funktion des Betrags — ohne Gruppierung laegen
     sie deckungsgleich uebereinander und einer waere unsichtbar. */
  function groupByThreshold(milestones) {
    var groups = [];
    var index = {};
    milestones.forEach(function (m) {
      var key = String(m.threshold);
      if (!index[key]) {
        index[key] = { threshold: m.threshold, items: [] };
        groups.push(index[key]);
      }
      index[key].items.push(m);
    });
    return groups;
  }

  /* Geld-Fortschritt: nur die Schwelle zaehlt, Verfuegbarkeit ist hier irrelevant. */
  function allReached(group) {
    return group.items.every(function (m) {
      return m.reached;
    });
  }

  /* Optischer Erfolg: erst wenn der Vorteil auch tatsaechlich einloesbar ist. */
  function allDelivered(group) {
    return group.items.every(function (m) {
      return m.reached && m.available;
    });
  }

  /* Ausverkauft schlaegt erreicht: eine erreichte, aber nicht einloesbare Schwelle darf nicht
     wie ein gewonnener Vorteil aussehen — free-products.js meldet darunter "ausverkauft". */
  function badgeStateClass(m) {
    if (!m.available) return 'cart-drawer__combined-progress__badge--soldout';
    if (m.reached) return 'cart-drawer__combined-progress__badge--reached';
    return 'cart-drawer__combined-progress__badge--upcoming';
  }

  /* Icon sitzt als Badge DIREKT AUF dem Track (nicht darueber schwebend), Betrag darunter.
     Sichtbares Label kommt nur aus dem Betrag — Screenreader wuessten sonst nicht, ob ein
     Badge Shipping oder Gift meint (Icon ist rein dekorativ). Deshalb je Badge ein
     verstecktes Text-Label voranstellen und das Icon aria-hidden setzen. */
  function renderMarkers(groups, maxThreshold, soldoutLabel) {
    return groups
      .map(function (g) {
        var pct = maxThreshold > 0 ? Math.min((g.threshold / maxThreshold) * 100, 100) : 0;
        var badges = g.items
          .map(function (m) {
            var label = m.available || !soldoutLabel ? m.label : m.label + ' ' + soldoutLabel;
            return (
              '<span class="cart-drawer__combined-progress__badge ' + badgeStateClass(m) + '">' +
                '<span class="visually-hidden">' + escapeHtml(label) + '</span>' +
                '<span class="cart-drawer__combined-progress__badge-icon" aria-hidden="true">' + m.icon + '</span>' +
              '</span>'
            );
          })
          .join('');
        var markerClass = allDelivered(g)
          ? 'cart-drawer__combined-progress__marker cart-drawer__combined-progress__marker--reached'
          : 'cart-drawer__combined-progress__marker';
        return (
          '<li class="' + markerClass + '" style="left: ' + pct + '%">' +
            '<span class="cart-drawer__combined-progress__badges">' + badges + '</span>' +
            '<span class="cart-drawer__combined-progress__amount">' + formatPrice(g.threshold) + '</span>' +
          '</li>'
        );
      })
      .join('');
  }

  /* Ein Segment je Betrag (0→m1, m1→m2, …). Jedes Segment traegt den erreicht-Zustand SEINES
     End-Meilensteins (Ticket-AC: "Icon + zugehoeriges Bar-Segment"). Der Teilfortschritt eines
     offenen Segments kommt aus der EIGENEN Basis seines Meilensteins — Shipping rechnet auf
     eligible_total (ohne notcount-Artikel), Gifts auf der co2-Summe. So mischen sich die beiden
     Summen nie zu einem gemeinsamen Fuellwert, der zu keinem der Marker passt. */
  function renderSegments(groups, maxThreshold) {
    var prevThreshold = 0;
    return groups
      .map(function (g) {
        var startPct = maxThreshold > 0 ? (prevThreshold / maxThreshold) * 100 : 0;
        var widthPct = maxThreshold > 0 ? ((g.threshold - prevThreshold) / maxThreshold) * 100 : 0;
        var span = g.threshold - prevThreshold;
        var localPct = 0;
        if (allReached(g)) {
          localPct = 100;
        } else {
          g.items.forEach(function (m) {
            if (m.current === null || m.current === undefined) return;
            var reachedInSpan = span > 0 ? ((m.current - prevThreshold) / span) * 100 : 0;
            localPct = Math.max(localPct, Math.min(Math.max(reachedInSpan, 0), 100));
          });
        }
        prevThreshold = g.threshold;
        return (
          '<div class="cart-drawer__combined-progress__segment" style="left: ' + startPct + '%; width: ' + widthPct + '%">' +
            /* &nbsp; verhindert :empty (base.css versteckt leere divs per display:none) */
            '<div class="cart-drawer__combined-progress__segment-fill" style="--segment-progress: ' + localPct + '%">&nbsp;</div>' +
          '</div>'
        );
      })
      .join('');
  }

  /* Die Meilensteine kommen vom kanonischen Root (siehe getCanonicalShippingRoot) und tragen
     ihre Basissumme selbst in `current` — dadurch rendert jeder Root denselben Stand, auch der
     Empty-State-Root, den der partielle Cart-Refresh nicht anfasst. */
  function render(root, milestones, giftsCheckedNow) {
    if (!milestones || milestones.length === 0) {
      hideBar(root);
      return;
    }

    milestones = milestones.slice().sort(function (a, b) {
      return a.threshold - b.threshold;
    });
    var groups = groupByThreshold(milestones);
    var maxThreshold = milestones[milestones.length - 1].threshold;

    /* Rail-Einzug rechts = halbe Breite der Badge-Gruppe am hoechsten Betrag, sonst ragt eine
       mehrfach belegte Gruppe ueber den Track hinaus. */
    root.style.setProperty('--cgp-marker-count', String(groups[groups.length - 1].items.length));

    showBar(
      root,
      '<div class="cart-drawer__combined-progress__status caption-large">' +
        buildHeadline(root, milestones, giftsCheckedNow) +
      '</div>' +
      '<div class="cart-drawer__combined-progress__track">' +
        '<div class="cart-drawer__combined-progress__rail">' +
          '<div class="cart-drawer__combined-progress__segments">' +
            renderSegments(groups, maxThreshold) +
          '</div>' +
          '<ul class="cart-drawer__combined-progress__markers">' +
            renderMarkers(groups, maxThreshold, root.dataset.textMilestoneSoldout || '') +
          '</ul>' +
        '</div>' +
      '</div>'
    );
  }

  /* Sofort-Render nur mit Shipping-Daten (synchron, aus dem DOM) — verhindert, dass die
     Bar auf ein erstes co2-Event warten muss und dadurch beim Oeffnen des Drawers leer
     erscheint (Kein-Layout-Shift-Anforderung des Tickets). Shipping-Werte kommen vom
     kanonischen Root (siehe getCanonicalShippingRoot), gelten fuer beide Roots. */
  function quickRenderShippingOnly() {
    var roots = getRoots();
    if (roots.length === 0) return;
    var canonicalRoot = getCanonicalShippingRoot(roots);
    var shipping = buildShippingMilestone(canonicalRoot);
    var milestones = shipping ? [shipping] : [];
    roots.forEach(function (root) {
      render(root, milestones, false);
    });
  }

  /* ─── Main Cycle ────────────────────────────────────────────── */

  async function updateUI() {
    var roots = getRoots();
    if (roots.length === 0) return;

    var canonicalRoot = getCanonicalShippingRoot(roots);
    var shipping = buildShippingMilestone(canonicalRoot);
    var giftMilestones = await buildGiftMilestones(canonicalRoot);
    /* Pro Zyklus neu bewertet, nicht dauerhaft gemerkt: faellt co2 nach einem erfolgreichen
       Zyklus aus, darf die Bar nicht weiter "alles erreicht" behaupten. */
    var giftsChecked = giftMilestones !== null;

    var milestones = shipping ? [shipping] : [];
    milestones = milestones.concat(giftMilestones || []);

    roots.forEach(function (root) {
      render(root, milestones, giftsChecked);
    });
  }

  async function triggerCycle() {
    if (isHandling) {
      pending = true;
      return;
    }
    isHandling = true;
    try {
      do {
        pending = false;
        await updateUI();
      } while (pending);
    } finally {
      isHandling = false;
    }
  }

  quickRenderShippingOnly();

  /* Zwei Trigger (wie free-products.js/tiered-pricing.js):
     - co2.cart.initialized: co2 hat frische Daten
     - PUB_SUB_EVENTS.cartRerendered: drawer-inner wurde neu in den DOM geschrieben;
       faengt den Fall ab, dass co2 vor dem replaceWith feuert. Trailing-edge de-dupt. */
  window.addEventListener('co2.cart.initialized', triggerCycle);
  subscribe(PUB_SUB_EVENTS.cartRerendered, triggerCycle);
})();
